import axios from 'axios';
import { ELECTRUM_API_URL } from '../consts';

export const postWebformToGoogleSheets = async (data) => {
  try {
    const response = await axios({
      method: 'POST',
      url: `${ELECTRUM_API_URL}/webform/submit`,
      config: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
      data,
    });

    return response.data;
  } catch (error) {
    console.error('Error submitting webform:', error);
    throw error;
  }
};